import React from 'react';

import 'react-day-picker/lib/style.css';
import { MessageSourceProps, withMessages } from 'react-message-source';
import styled from 'styled-components';

const PickerContainerDiv = styled.div`

  &.color-picker-box {
    display: inline-block;
    padding-right: 2rem;

    label {
      display: inline-block;
      padding-right: 0.5rem;
    }

    .choose-color-box {
      display: inline-block;

      .choose-color-swatch {
        margin-bottom: -0.5rem;
      }
    }
  }
`;

interface FinalFormTopRowEntityColorPickerFieldProps extends MessageSourceProps {
}

const FinalFormTopRowEntityColorPicker: React.FC<FinalFormTopRowEntityColorPickerFieldProps> = (
    {getMessage, children}) => {

  return <PickerContainerDiv className="color-picker-box">
    <label>{getMessage("common.color")}:</label>
    {children}
  </PickerContainerDiv>
};

export default withMessages(FinalFormTopRowEntityColorPicker);
